import React, { useEffect, useState } from 'react';
import { hrmsListCandidates, hrmsListNotifs } from '../../lib/hrmsApi';

export const CandidatesPage = () => {
  const [rows, setRows] = useState([]);
  useEffect(() => { hrmsListCandidates().then(setRows).catch(() => setRows([])); }, []);
  return (
    <div>
      <h1 className="text-2xl font-extrabold">Candidates</h1>
      <div className="mt-6 rounded-2xl border bg-white overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-100 text-slate-700"><tr><th className="text-left px-4 py-3">Candidate ID</th><th className="text-left px-4 py-3">Name</th><th className="text-left px-4 py-3">Email</th><th className="text-left px-4 py-3">Mobile</th><th className="text-left px-4 py-3">Applied</th></tr></thead>
          <tbody>
            {rows.length === 0 && <tr><td colSpan={5} className="px-4 py-10 text-center text-slate-500">No candidates yet.</td></tr>}
            {rows.map((c) => (
              <tr key={c.id} className="border-t">
                <td className="px-4 py-3 font-mono text-xs">{c.candidate_id}</td>
                <td className="px-4 py-3 font-medium">{c.full_name}</td>
                <td className="px-4 py-3">{c.email}</td>
                <td className="px-4 py-3">{c.mobile}</td>
                <td className="px-4 py-3 text-slate-500">{new Date(c.created_at).toLocaleDateString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export const NotificationsPage = () => {
  const [rows, setRows] = useState([]);
  useEffect(() => { hrmsListNotifs().then(setRows).catch(() => setRows([])); }, []);
  return (
    <div>
      <h1 className="text-2xl font-extrabold">Notifications</h1>
      <div className="mt-4 space-y-2">
        {rows.length === 0 && <div className="text-slate-500 text-sm">No notifications.</div>}
        {rows.map((n) => (
          <div key={n.id} className="rounded-xl border bg-white p-4">
            <div className="text-sm font-semibold text-slate-900">{n.title}</div>
            <div className="text-xs text-slate-500 mt-1">{new Date(n.created_at).toLocaleString()}</div>
          </div>
        ))}
      </div>
    </div>
  );
};
